module.exports = __webpack_public_path__ + "static/media/subscribers.8c99ed08.xml";


//////////////////
// WEBPACK FOOTER
// ./public/subscribers.xml
// module id = 1825
// module chunks = 1